import { render, staticRenderFns } from "./recaudacion.vue?vue&type=template&id=0e67a9ea"
import script from "./recaudacion.vue?vue&type=script&lang=js"
export * from "./recaudacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports